/* eslint-disable */
import React from 'react'
import {Checkbox, message} from 'antd'
import {MDBBreadcrumb, MDBBreadcrumbItem, ModalBody} from 'mdbreact'
import {Link} from 'react-router-dom'
import moment from 'moment'
import {saveAs} from 'file-saver'
import FromToPicker from '../BaseComponent/FromToPicker'
import JASPERREPORT from '../BaseComponent/JASPERREPORT'
import Select from 'react-select'
import http from '../Interceptor/Interseptor'
import REPORT_RETAIL from '../BaseComponent/REPORTRETAIL'
import WAREHOUSE from '../BaseComponent/WAREHOUSE'
import Loader from '../loaders/loader'
import {ExcelExport, grid, gridColumn} from '@progress/kendo-react-excel-export'
import AutoComplete from '../BaseComponent/autocomplete'

class MasterSupplyOrder extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      selectedDateFrom: moment(),
      selectedDateTo: moment(),
      fromDate: '',
      toDate: '',
      providers: [],
      warehouses: [],
      selectedWarehouse: null,
      inventory: false,
      deliveryLocations: [],
      deliveryLocation: [],
      deliveryBehaviours: [],
      deliveryBehaviour: []
    }
  }
  componentDidMount() {
    // http.get(`${REPORT_RETAIL.REPORT_RETAIL_LIST_PROVIDER}`, {}).then((response) => {

    //     if (response.data.error == null) {

    //         var result = response.data.object;
    //         for (let i = 0; i < result.length; i++) {
    //             result[i]['value'] = result[i].providerId;
    //             result[i]['label'] =result[i].providerId + ' - ' + result[i].title;
    //         }

    //         this.setState({
    //             providers: response.data.object
    //         })
    //     }
    //     // alert(JSON.stringify(response.data))
    // }).catch((error) => {
    //     alert(JSON.stringify(error))
    // });

    http.get(`${WAREHOUSE.WAREHOUSE_TYPE_LIST_WAREHOUSE}`, {}).then((response) => {
      if (response.data.error == null) {
        let result = response.data.object
        for (let i = 0; i < result.length; i++) {
          result[i]['value'] = result[i].id
          result[i]['label'] = result[i].name + ' - ' + result[i].typePrimaryName
        }
        this.setState({
          warehouses: result
        })
      }
    })
    http.get(`report/retail/list/delivery-behaviour`, {}).then((response) => {
      if (response.data.error == null) {
        let result = response.data.object
        for (let i = 0; i < result.length; i++) {
          result[i]['value'] = result[i].deliveryBehaviourId
          result[i]['label'] = result[i].name
        }
        this.setState({
          deliveryBehaviours: result
        })
      }
    })
    http.get(`report/retail/list/delivery-location`, {}).then((response) => {
      if (response.data.error == null) {
        let result = response.data.object
        for (let i = 0; i < result.length; i++) {
          result[i]['value'] = result[i].deliveryLocationId
          result[i]['label'] = result[i].name
        }
        this.setState({
          deliveryLocations: result
        })
      }
    })
  }

  submit(e) {
    e.preventDefault()
  }

  handleChangeFromDate = (fromDate) => {
    this.setState({
      fromDate
    })
  }

  handleChangeToDate = (toDate) => {
    this.setState({
      toDate
    })
  }

  changeDeliveryBehavior = (deliveryBehaviour) => {
    this.setState({deliveryBehaviour})
  }
  changeDeliveryLocation = (deliveryLocation) => {
    this.setState({deliveryLocation})
  }

  handleChange = (selectedOption) => {
    this.setState({selectedOption})
  }

  changeWarehouse = (selectedWarehouse) => {
    this.setState({selectedWarehouse})
  }

  makeReport() {
    let providerId = this.state.providerId ? this.state.providerId : ''
    let inventoryId =
      this.state.selectedWarehouse == null || this.state.selectedWarehouse == ''
        ? ''
        : this.state.selectedWarehouse.externalId
    let deliveryBehaviour = this.state.deliveryBehaviour.length === 0 ? [] : this.state.deliveryBehaviour
    let deliveryLocation = this.state.deliveryLocation.length === 0 ? [] : this.state.deliveryLocation
    let behaviorArr = []
    deliveryBehaviour.forEach((item) => {
      behaviorArr.push(item.deliveryBehaviourId)
    })

    let locationArr = []
    deliveryLocation.forEach((item) => {
      locationArr.push(item.deliveryLocationId)
    })

    let minDate = this.state.fromDate
    let maxDate = this.state.toDate

    if (minDate == '' || maxDate == '') {
      message.error('هر دو تاریخ وارد شود')
    } else if ((minDate != '' || minDate == null) && isNaN(minDate)) {
      message.error('فرمت تاریخ ابتدا صحیح نیست')
    } else if ((maxDate != '' || maxDate == null) && isNaN(maxDate)) {
      message.error('فرمت تاریخ انتها صحیح نیست')
    } else {
      JASPERREPORT(
        `report/jasper/dispatch/master/supply-order?shiftDateMin=${minDate}&shiftDateMax=${maxDate}&sellerId=${providerId}&inventory=${
          this.state.inventory
        }&inventoryId=${inventoryId}&deliveryBehaviour=${behaviorArr}&deliveryLocation=${locationArr}`
      )
    }
  }

  aggregated() {
    let providerId = this.state.providerId ? this.state.providerId : ''
    let inventoryId =
      this.state.selectedWarehouse == null || this.state.selectedWarehouse == ''
        ? ''
        : this.state.selectedWarehouse.externalId
    let deliveryBehaviour = this.state.deliveryBehaviour.length === 0 ? [] : this.state.deliveryBehaviour
    let deliveryLocation = this.state.deliveryLocation.length === 0 ? [] : this.state.deliveryLocation
    let behaviorArr = []
    deliveryBehaviour.forEach((item) => {
      behaviorArr.push(item.deliveryBehaviourId)
    })

    let locationArr = []
    deliveryLocation.forEach((item) => {
      locationArr.push(item.deliveryLocationId)
    })

    let minDate = this.state.fromDate
    let maxDate = this.state.toDate

    if (minDate == '' || maxDate == '') {
      message.error('هر دو تاریخ وارد شود')
    } else if ((minDate != '' || minDate == null) && isNaN(minDate)) {
      message.error('فرمت تاریخ ابتدا صحیح نیست')
    } else if ((maxDate != '' || maxDate == null) && isNaN(maxDate)) {
      message.error('فرمت تاریخ انتها صحیح نیست')
    } else {
      JASPERREPORT(
        `report/jasper/supplier/orders/aggregated/all?shiftDateMin=${minDate}&shiftDateMax=${maxDate}&sellerId=${providerId}&inventory=${
          this.state.inventory
        }&inventoryId=${inventoryId}&deliveryBehaviour=${behaviorArr}&deliveryLocation=${locationArr}`
      )
    }
  }
  detailed() {
    let providerId = this.state.providerId ? this.state.providerId : ''
    let inventoryId =
      this.state.selectedWarehouse == null || this.state.selectedWarehouse == ''
        ? ''
        : this.state.selectedWarehouse.externalId
    let deliveryBehaviour = this.state.deliveryBehaviour.length === 0 ? [] : this.state.deliveryBehaviour
    let deliveryLocation = this.state.deliveryLocation.length === 0 ? [] : this.state.deliveryLocation
    let behaviorArr = []
    deliveryBehaviour.forEach((item) => {
      behaviorArr.push(item.deliveryBehaviourId)
    })

    let locationArr = []
    deliveryLocation.forEach((item) => {
      locationArr.push(item.deliveryLocationId)
    })

    let minDate = this.state.fromDate
    let maxDate = this.state.toDate

    if (minDate == '' || maxDate == '') {
      message.error('هر دو تاریخ وارد شود')
    } else if ((minDate != '' || minDate == null) && isNaN(minDate)) {
      message.error('فرمت تاریخ ابتدا صحیح نیست')
    } else if ((maxDate != '' || maxDate == null) && isNaN(maxDate)) {
      message.error('فرمت تاریخ انتها صحیح نیست')
    } else {
      JASPERREPORT(
        `report/jasper/supplier/orders/detailed/all?shiftDateMin=${minDate}&shiftDateMax=${maxDate}&sellerId=${providerId}&inventory=${
          this.state.inventory
        }&inventoryId=${inventoryId}&deliveryBehaviour=${behaviorArr}&deliveryLocation=${locationArr}`
      )
    }
  }

  getExcel = () => {
    this.setState({
      loading: true
    })
    let providerId = this.state.providerId ? this.state.providerId : ''
    let inventoryId =
      this.state.selectedWarehouse == null || this.state.selectedWarehouse == ''
        ? ''
        : this.state.selectedWarehouse.externalId
    let deliveryBehaviour = this.state.deliveryBehaviour.length === 0 ? [] : this.state.deliveryBehaviour
    let deliveryLocation = this.state.deliveryLocation.length === 0 ? [] : this.state.deliveryLocation
    let minDate = this.state.fromDate
    let maxDate = this.state.toDate
    let behaviorArr = []
    deliveryBehaviour.forEach((item) => {
      behaviorArr.push(item.deliveryBehaviourId)
    })

    let locationArr = []
    deliveryLocation.forEach((item) => {
      locationArr.push(item.deliveryLocationId)
    })

    if (minDate == '' || maxDate == '') {
      message.error('هر دو تاریخ وارد شود')
    } else if ((minDate != '' || minDate == null) && isNaN(minDate)) {
      message.error('فرمت تاریخ ابتدا صحیح نیست')
    } else if ((maxDate != '' || maxDate == null) && isNaN(maxDate)) {
      message.error('فرمت تاریخ انتها صحیح نیست')
    } else {
      http
        .get(
          `report/jasper/dispatch/master/supply-order/json?shiftDateMin=${minDate}&shiftDateMax=${maxDate}&sellerId=${providerId}&inventory=${
            this.state.inventory
          }&inventoryId=${inventoryId}&deliveryBehaviour=${behaviorArr}&deliveryLocation=${locationArr}`,
          {}
        )
        .then((res) => {
          if (res.data.error === null) {
            let result = res.data.object.supplyOrderMasterReportViewList
            result.forEach((item) => {
              item.address = item.address ? item.address.trim() : ''
              item.baze = item.startTime.substr(0, 5) + ' - ' + item.endTime.substr(0, 5)
            })
            this.setState(
              {
                loading: false,
                excel: result
              },
              () => {
                this._export.save(this.state.excel)
              }
            )
          } else {
            this.setState({
              loading: false
            })
          }
        })
        .catch(() => {
          this.setState({
            loading: false
          })
        })
    }
  }

  render() {
    let {selectedOption} = this.state

    return (
      <div className="rtl printA4Page">
        <Loader show={this.state.loading} />
        <div className="excelSection">
          <ExcelExport
            dir="rtl"
            ref={(exporter) => {
              this._export = exporter
            }}
            fileName="گزارش سرجمع سفارش تامین کنندگان.xls"
          >
            <grid style={{height: '420px'}} data={this.state.excel}>
              <gridColumn
                key={'sellerName'}
                field={'sellerName'}
                title={'تامین کننده'}
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'inventoryName'}
                field={'inventoryName'}
                title={'انبار'}
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'shiftDate'}
                field={'shiftDate'}
                title={'تاریخ شیفت انبار'}
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'baze'}
                field={'baze'}
                title={'بازه انبار'}
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'deliveryLocation'}
                field={'deliveryLocation'}
                title={'محل تحویل'}
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'deliveryBehaviour'}
                field={'deliveryBehaviour'}
                title={'رفتار تحویل'}
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'address'}
                field={'address'}
                title={'آدرس'}
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'masir'}
                field={'masir'}
                title={'مسیر'}
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
            </grid>
          </ExcelExport>
        </div>
        <div className="wrapperIframe">
          <ul className="breadcrumb">
            <li>
              <Link to={'/search'}>به روزرسان</Link>
            </li>
            <li>گزارشات</li>
            <li>سفارش تامین کنندگان</li>
            <li>سر جمع سفارش تامین کنندگان</li>
          </ul>
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-12 col-md-9">
                <form className="verticalForm w-100" onSubmit={this.submit.bind(this)}>
                  <div className="headerVertical">
                    <p>سر جمع سفارش تامین کنندگان</p>
                  </div>
                  <div className="row">
                    <div className="col-12">
                      <FromToPicker
                        onChangeFromDate={this.handleChangeFromDate}
                        onChangeToDate={this.handleChangeToDate}
                        fromLabel="شیفت انبار از"
                        toLabel="شیفت انبار تا"
                        force={true}
                        defaulValue={true}
                        fromId="from"
                        toId="to"
                      />
                    </div>
                    <div className="col-12 col-md-6">
                      <div className="formComponent selectComponent">
                        <AutoComplete
                          label="تامین کننده"
                          api={`${REPORT_RETAIL.REPORT_RETAIL_LIST_PROVIDER}`}
                          textField="title"
                          valueField="providerId"
                          id="provider"
                          value={this.state.providerId}
                          setValue={(providerId) => this.setState({providerId})}
                        />
                        {/* <label>تامین کننده :‌</label>
                                                <Select
                                                    value={selectedOption}
                                                    onChange={this.handleChange}
                                                    options={this.state.providers}
                                                    isMulti={false}
                                                    isClearable={true}
                                                    placeholder={''}
                                                    id="input_supplierName"
                                                    name="input_supplierName"
                                                /> */}
                      </div>
                    </div>
                    <div className="col-12 col-md-6">
                      <div className="formComponent selectComponent">
                        <label>انبار :‌</label>
                        <Select
                          value={this.state.selectedWarehouse}
                          onChange={this.changeWarehouse}
                          options={this.state.warehouses}
                          isMulti={false}
                          isClearable={true}
                          placeholder={''}
                          id="inventoryId"
                          name="inventoryId"
                        />
                      </div>
                    </div>
                    <div className="col-12 col-md-6">
                      <div className="formComponent selectComponent">
                        <label>محل تحویل :‌</label>
                        <Select
                          value={this.state.deliveryLocation}
                          onChange={this.changeDeliveryLocation}
                          options={this.state.deliveryLocations}
                          isMulti={true}
                          isClearable={true}
                          placeholder={''}
                          id="deliveryLocation"
                          name="deliveryLocation"
                        />
                      </div>
                    </div>
                    <div className="col-12 col-md-6">
                      <div className="formComponent selectComponent">
                        <label>رفتار تحویل :‌</label>
                        <Select
                          value={this.state.deliveryBehaviour}
                          onChange={this.changeDeliveryBehavior}
                          options={this.state.deliveryBehaviours}
                          isMulti={true}
                          isClearable={true}
                          placeholder={''}
                          id="deliveryBehavior"
                          name="deliveryBehavior"
                        />
                      </div>
                    </div>
                    <div className="col-12 col-md-6">
                      <div className="formComponent selectComponent">
                        <Checkbox
                          className="form-check"
                          name="inventory"
                          checked={this.state.inventory}
                          onChange={() => this.setState({inventory: !this.state.inventory})}
                        >
                          گروه بندی بر اساس انبار
                        </Checkbox>
                      </div>
                    </div>
                  </div>
                  <div className="row mx-0">
                    <div className="col-12 col-md-6 p-2">
                      <button className="btn btn-info btn-block jasperBtn" onClick={this.makeReport.bind(this)}>
                        ساخت گزارش
                      </button>
                    </div>
                    <div className="col-12 col-md-6 p-2">
                      <button className="btn btn-info btn-block jasperBtn" onClick={this.detailed.bind(this)}>
                        چاپ اقلام ریز
                      </button>
                    </div>
                    <div className="col-12 col-md-6 p-2">
                      <button className="btn btn-info btn-block jasperBtn" onClick={this.aggregated.bind(this)}>
                        چاپ اقلام تجمیعی
                      </button>
                    </div>
                    <div className="col-12 col-md-6 p-2">
                      <button className="btn btn-info btn-block jasperBtn" onClick={this.getExcel}>
                        دریافت فایل اکسل
                      </button>
                    </div>
                  </div>
                  <div className="formComponent selectComponent">
                    <p className="errorText" id="errorText" />
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}
export default MasterSupplyOrder
